import { useMutation } from '@tanstack/react-query';
import { operationApis } from '../../../../../../../shared/apis/operation/apis';

export function useEditPopup() {
  const { mutate: editPopup } = useMutation(operationApis.putPopup);

  return { editPopup };
}
